import { type FC, type ReactNode } from "react";
import classNames from "classnames";
import {
  Box,
  styled,
  TableSortLabel as MuiTableSortLabel,
  type TableSortLabelProps as MuiTableSortLabelProps,
} from "~/common/mui";
import { Icon } from "../icon/Icon";
import { IconType } from "../icon/IconType";
import { IconSize } from "../icon/IconSize";
import { C_ON_SURFACE, C_PRIMARY, C_PRIMARY_HOVER } from "../icon/Colors";

export { Table, TableHead, TableBody, TableRow, TableCell } from "~/common/mui";

const HeaderContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  fontWeight: "bold",
});

const SubHeader = styled("div")({
  fontWeight: "normal",
  color: "var(--color-text-secondary, #666)", // Assuming f-label-color maps to this or similar
});

type HeaderCellTitleProps = JSX.IntrinsicElements["div"] & {
  header: ReactNode;
  subheader?: ReactNode;
  children?: never;
  subHeaderClass?: string;
};
export const HeaderCellTitle: FC<HeaderCellTitleProps> = (props) => {
  const { header, subheader, className, subHeaderClass, ...rest } = props;

  return (
    <HeaderContainer className={className} {...rest}>
      {header}
      {subheader && <SubHeader className={subHeaderClass}>{subheader}</SubHeader>}
    </HeaderContainer>
  );
};

const StyledTableSortLabel = styled(MuiTableSortLabel)({
  color: C_ON_SURFACE,
  alignItems: "flex-start",
  "&:hover": {
    color: C_PRIMARY,
    "& .MuiTableSortLabel-icon": {
      opacity: 1,
    },
  },
  "&.Mui-active": {
    color: C_PRIMARY,
    "&:hover": {
      color: C_PRIMARY_HOVER,
    },
  },
  "& .MuiTableSortLabel-icon": {
    opacity: 1,
    fontSize: "10px",
    marginRight: "8px",
    marginLeft: 0,
    lineHeight: "18px",
    color: "inherit !important",
  },
});

export const TableSortLabel = (props: MuiTableSortLabelProps) => {
  return <StyledTableSortLabel {...props} IconComponent={renderIcon} />;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const renderIcon = (props: any) => <Icon type={IconType.ArrowDown} size={IconSize.FONT_10} {...props} />;
